import { Formik } from "formik";
import { injectIntl } from "react-intl";
import {
  ButtonGroup,
  Column,
  Form,
  intlShape,
  isEmpty,
  Row,
  SubmitButton,
} from "lcm-iot-commons";
import withZxcvbn, { zxcvbnShape } from "../../wrappers/withZxcvbn";
import PasswordInput from "../Form/PasswordInput";

type OwnProps = {
  intl: intlShape;
  onSubmit?: $TSFixMeFunction;
  zxcvbn: zxcvbnShape;
};

const defaultProps: Partial<OwnProps> = {
  onSubmit: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function PasswordResetForm({ intl, onSubmit, zxcvbn }: Props) {
  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (isEmpty(values.password)) {
      (errors as $TSFixMe).password = intl.formatMessage({
        id: "validation.password.mandatory",
      });
    } else {
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      const passwordError = zxcvbn.checkPassword(values.password).error;
      if (passwordError) {
        (errors as $TSFixMe).password = passwordError;
      }
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <Row id="user-password">
          <Column md={8}>
            <PasswordInput
              {...formProps}
              label={intl.formatMessage({ id: "label.password" })}
              intl={intl}
              id="password"
              name="password"
              type="password"
              disabled={isSubmitting}
              required
            />
          </Column>
        </Row>
        {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; className: string; }' i... Remove this comment to see the full error message */}
        <ButtonGroup className="btn-group">
          <SubmitButton
            id="renew-button"
            fetching={isSubmitting}
            disabled={isSubmitting}
            text={intl.formatMessage({
              id: "password_reset.button_renew_password",
            })}
          />
        </ButtonGroup>
      </Form>
    );
  };

  return (
    <div className="row">
      <div className="col-sm-6">
        <h1>{intl.formatMessage({ id: "password_reset.header" })}</h1>
        <p>{intl.formatMessage({ id: "password_reset.enter_new_password" })}</p>
        <div className="form-group">
          <Formik
            id="edit-password-form"
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onSubmit={onSubmit}
            validate={validateForm}
            initialValues={{}}
          >
            {renderForm}
          </Formik>
        </div>
      </div>
    </div>
  );
}

PasswordResetForm.defaultProps = defaultProps;

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(withZxcvbn(PasswordResetForm));
